import list from './list';
import form from './form';
import accordions from './accordion';
import attrEditResources from './attr-edit-resources';
import styleEditResource from './style-edit-resources';
import animEditResources from './anim-edit-resources';
import wrapperEditResources from './wrapper-edit-resources';
import settingsEditResources from './settings-edit-resources';
import basePropEditResources from './base-prop-edit-resources';
export default {
    form,
    btn: list,
    links: list,
    accordions,
    toggle: { style: styleEditResource },
    dynamicText: { style: styleEditResource },
    ...basePropEditResources,
    attr: attrEditResources,
    style: styleEditResource,
    animation: animEditResources,
    wrapper: wrapperEditResources,
    settings: settingsEditResources,
};
